//custom js aquí
jQuery(document).ready(function() {
	// equal height aux
	$('.av-equal-1').matchHeight();

	$('.av-toggle-menu').click(function () {
		$(this).toggleClass('active');
		$('.av-header__menu--mobile').toggleClass('opened');
		$('body').toggleClass("body-noscroll");
	});

	$('.header__menu-mobile .nav-link').click(function () {
		$('body').removeClass("body-noscroll");
		$('.toggle-menu').removeClass('active');
		$('.header__menu-mobile').removeClass('opened');
	});

	$('a[class^="av-dropdown-mobile"]').click(function (e) {
		e.preventDefault();
		let id = $(this).data("dropdown");
		$(`#${id}`).addClass('active');
	});

	$('.av-link--back').click(function (e) {
		$(this).parents('ul').removeClass('active');
	});

	//Mostrar textarea
	$('#check-messaje').click(function(e){
		if($(this).is(':checked')){
			//console.log("mostrar");
			$('#messaje').toggle("slow");
			//$('#messaje').removeClass("d-none");
		}else{
			//console.log("ocultar");
			$('#messaje').toggle("slow");
			//$('#messaje').addClass("d-none");
		}
	});

	//TAB
	$('.mdc-tab').click(function(e){
		let id = $(this).data("tab");

		if($(window).width() >= 992){
			let desktopElement = $('.section-two');
			for (const element of desktopElement) {
				element.setAttribute('style', 'display:none !important;')
				if(id == '#'+element.dataset.tab_id) {
					element.setAttribute('style', '');
				}
			}
		}else {
			let mobileElement = $('.card-mobiles');
			for (const element of mobileElement) {
				element.setAttribute('style', 'display:none !important;')
				element.classList.remove('active');
				if(id.split('-')[1] == element.dataset.id_cat) {
					element.setAttribute('style', '');
					element.classList.add('active');
				}
			}
		}

		$('.tab-content').removeClass("active");
		$(id).addClass("active");
	});

	//close bar fixed
	$('.bar-fixed .close-fixed').click(function(){
		$(".bar-fixed").hide("slow");
	});

	//slider
	/* $('.slider').slick(); */
	$('.slider').slick({
		dots: true,
		arrows: true,
		prevArrow: $('#arrow-left-sd'),
		nextArrow: $('#arrow-right-sd')
	});

	$('.av-slider').slick({
		dots: true,
		arrows: true,
		prevArrow: $('#arrow-left-sd'),
		nextArrow: $('#arrow-right-sd'),
		slidesToShow: 1,
		slidesToScroll: 1
	 });
	/* ancla scrol top */
	$('body').on('click','a[data-indice]', function () { 
		//console.log(this);
		let target = $('#' + this.dataset.indice);
		if (target.length) {
			let targetOffset = target.offset().top - 120;
			$('html,body').animate({ scrollTop: targetOffset }, 1000);
		}
	});
	
	if (location.hash) {
		let hashUrl = location.hash.replace('#', '');
		let target = $('#' + hashUrl);
		if (target.length) {
			let targetOffset = target.offset().top - 120;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 1000);
		}
	}

	// dropdown comments
	$('a[class^="av-dropdown-mobile"] a[data-dropdown]').click((event)=>{
		let el = event.target;
		let heightDropdownContent = el.parentElement.nextElementSibling.offsetHeight,
			heightOfEl = el.offsetHeight;
		!el.parentElement.nextElementSibling.classList.contains('active') ? el.parentElement.parentElement.setAttribute('style', `height:${heightDropdownContent + heightOfEl + 75}px;transition:all 820ms ease-in-out;`) : el.parentElement.parentElement.removeAttribute('style');
		!el.parentElement.nextElementSibling.classList.contains('active') ? el.parentElement.nextElementSibling.classList.add('active') : el.parentElement.nextElementSibling.classList.remove('active');
	});
	$(document).on('click','.modal-contact',function(){
		$('.contact-modal').modal('show');
	});
	
	$(document).on('click','.modal-empresa',function(){
		$('.contact-modal-empresa').modal('show');
	});
});//custom js aqui

